import { Injectable } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';

export const DE_FORMATS = {
    parse: {
        dateInput: 'MM/YYYY',
    },
    display: {
        dateInput: 'MM/YYYY',
        monthYearLabel: 'MMM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY',
    },
};

export const MONTHS = {
    1: 'Januar',
    2: 'Februar',
    3: 'März',
    4: 'April',
    5: 'Mai',
    6: 'Juni',
    7: 'Juli',
    8: 'August',
    9: 'September',
    10: 'Oktober',
    11: 'November',
    12: 'Dezember',
};

@Injectable({
    providedIn: 'root',
})
export class HyundaiDateAdapter extends NativeDateAdapter {
    override parse(value: string | number): Date | null {
        if (typeof value === 'string' && value.includes('/')) {
            const str = value.split('/');
            if (str.length < 2 || Number.isNaN(+str[0]) || Number.isNaN(+str[1]) || Number.isNaN(+str[2])) {
                return null;
            }
            return new Date(Number(str[2]), Number(str[1]) - 1, Number(str[0]), 12);
        }
        const timestamp = typeof value === 'number' ? value : Date.parse(value);
        return Number.isNaN(timestamp) ? null : new Date(timestamp);
    }
    override getFirstDayOfWeek(): number {
        return 1;
    }
    override getDayOfWeekNames(): string[] {
        const SHORT_NAMES = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'];
        return SHORT_NAMES;
    }
}

function isWeekdayDisabled(date: Date, disabledWeekDays: number[]): boolean {
    const dayOfWeek = date.getDay();
    return disabledWeekDays.includes(dayOfWeek);
}

function isDateDisabled(date: Date, disabledDays: Date[]): boolean {
    return disabledDays.some((disabledDate) => isSameDay(date, disabledDate));
}

function isSameDay(date1: Date, date2: Date): boolean {
    return (
        date1.getFullYear() === date2.getFullYear() &&
        date1.getMonth() === date2.getMonth() &&
        date1.getDate() === date2.getDate()
    );
}

function isDisabled(date: Date, disabledWeekDays: number[], disabledDays: Date[]): boolean {
    return isWeekdayDisabled(date, disabledWeekDays) || isDateDisabled(date, disabledDays);
}

export function filterDates(date: Date, disabledWeekDays?: number[], disabledDays?: Date[]): boolean {
    if (disabledWeekDays && disabledDays) {
        return !isDisabled(date, disabledWeekDays, disabledDays);
    }

    if (disabledWeekDays) {
        return !isWeekdayDisabled(date, disabledWeekDays);
    }

    if (disabledDays) {
        return !isDateDisabled(date, disabledDays);
    }

    return true;
}
